import { ITEM_IDS } from '../data/item-ids';
import { ItemTextMap } from './mergeCategoryWithLocale';

const EN: Record<string, string> = {
  [ITEM_IDS.indoors.pillows]: 'Pillows',
  [ITEM_IDS.indoors.blankets]: 'Blankets',
  [ITEM_IDS.indoors.sleepingBag]: 'A sleeping bag and insulated liner',
  [ITEM_IDS.indoors.airMattress]: 'An air mattress, pump and repair kit',
  [ITEM_IDS.indoors.powerBank]: 'Power bank',
  [ITEM_IDS.outdoors.tent]: 'A season-appropriate tent and tent stakes',
  [ITEM_IDS.outdoors.flashlights]: 'Flashlights and/or headlamps',
  [ITEM_IDS.outdoors.cooler]: 'A spacious cooler and ice',
  [ITEM_IDS.outdoors.firestarter]: 'Matches, firestarter or a lighter',
  [ITEM_IDS.outdoors.kindling]: 'Kindling/charcoal to help start a campfire',
  [ITEM_IDS.outdoors.citronella]: 'Citronella candles to repel insects',
  [ITEM_IDS.furniture.pavilion]: 'A pop-up pavilion or shade structure',
  [ITEM_IDS.furniture.hammock]: 'A hammock',
  [ITEM_IDS.furniture.chairs]: 'At least one camping chair per person',
  [ITEM_IDS.furniture.table]: 'A folding table',
  [ITEM_IDS.clothes.tshirts]: 'T-shirts',
  [ITEM_IDS.clothes.layering]: 'Light layering pieces',
  [ITEM_IDS.clothes.raincoat]: 'A raincoat',
  [ITEM_IDS.clothes.sweater]: 'A sweater, hoodie or fleece pullover',
  [ITEM_IDS.clothes.socks]: 'Thick socks, preferably made of wool',
  [ITEM_IDS.clothes.pantsShorts]: 'Pants and shorts',
  [ITEM_IDS.clothes.underwear]: 'Underwear',
  [ITEM_IDS.clothes.swimsuit]: 'A swimsuit or swimming trunks',
  [ITEM_IDS.clothes.sunhat]: 'A wide-brimmed sunhat or visor',
  [ITEM_IDS.clothes.sunglasses]: 'Sunglasses',
  [ITEM_IDS.clothes.hikingBoots]: 'Hiking boots',
  [ITEM_IDS.clothes.sandals]: 'Sandals or flip-flops',
  [ITEM_IDS.food.spices]: 'Spices, herbs and seasonings, including salt and pepper',
  [ITEM_IDS.food.eggs]: 'Eggs',
  [ITEM_IDS.food.cookingOil]: 'Cooking oil',
  [ITEM_IDS.food.drinks]: 'Bottled water, soda and juice',
  [ITEM_IDS.food.smores]:
    'S\u2019mores ingredients, including marshmallows, chocolate and graham crackers/skewers',
  [ITEM_IDS.food.produce]: 'Fresh fruits and vegetables',
  [ITEM_IDS.food.meats]: 'Meats for barbecuing',
  [ITEM_IDS.food.condiments]:
    'Condiments, including ketchup, mustard, relish and mayonnaise',
  [ITEM_IDS.food.bread]: 'A loaf of bread',
  [ITEM_IDS.food.deli]: 'Sliced cheese and deli meat',
  [ITEM_IDS.food.snacks]: 'Grab-and-go snacks, like trail mix and energy bars',
  [ITEM_IDS.food.saltySnacks]: 'Chips, pretzels or other salty snacks',
  [ITEM_IDS.food.beer]: 'Beer/other drinks',
  [ITEM_IDS.food.foodBowlsWithLids]: 'Tupperware',
  [ITEM_IDS.food.servingBowls]: 'Large serving bowls',
  [ITEM_IDS.hygiene.handSoap]: 'Hand soap',
  [ITEM_IDS.hygiene.towels]: 'Bath towels and washcloths',
  [ITEM_IDS.hygiene.bodySoap]: 'Body soap, shampoo and conditioner',
  [ITEM_IDS.hygiene.hairbrush]: 'A hairbrush',
  [ITEM_IDS.hygiene.toothbrush]: 'A toothbrush and toothpaste',
  [ITEM_IDS.hygiene.cottonSwabs]: 'Cotton swabs',
  [ITEM_IDS.hygiene.toiletPaper]: 'Toilet paper',
  [ITEM_IDS.hygiene.menstrual]: 'Menstrual products',
  [ITEM_IDS.hygiene.deodorant]: 'Deodorant',
  [ITEM_IDS.hygiene.babyWipes]: 'Baby wipes, for quick wipe-downs between washes',
  [ITEM_IDS.recreational.fishing]: 'Fishing poles and tackle',
  [ITEM_IDS.recreational.boardGames]: 'Board games and playing cards',
  [ITEM_IDS.recreational.books]: 'Books',
  [ITEM_IDS.recreational.speaker]: 'A music player and speaker',
  [ITEM_IDS.recreational.binoculars]: 'Binoculars',
  [ITEM_IDS.recreational.sports]: 'Frisbees, volleyballs, footballs',
  [ITEM_IDS.cleanUp.paperTowels]: 'Paper towels',
  [ITEM_IDS.cleanUp.trashBags]: 'Trash bags',
  [ITEM_IDS.cleanUp.sponge]: 'A cleaning sponge',
  [ITEM_IDS.cleanUp.dirtyClothesBags]: 'Plastic bags for dirty clothes',
  [ITEM_IDS.cleanUp.stainRemover]: 'A stain-remover pen for clothes',
  [ITEM_IDS.cleanUp.portableSink]: 'A portable sink or basin for dishwashing',
  [ITEM_IDS.safety.handSanitizer]: 'Hand sanitizer',
  [ITEM_IDS.safety.spareCash]: 'Spare cash',
  [ITEM_IDS.safety.sunscreen]: 'High SPF, water-resistant sunscreen',
  [ITEM_IDS.safety.insectRepellant]: 'Insect repellent',
  [ITEM_IDS.safety.spareBatteries]: 'Spare batteries',
  [ITEM_IDS.firstAid.bandages]: 'Adhesive bandages',
  [ITEM_IDS.firstAid.alcohol]: 'Alcohol',
  [ITEM_IDS.firstAid.antiItch]: 'Anti-itch medication',
  [ITEM_IDS.firstAid.tweezers]: 'Tweezers',
  [ITEM_IDS.firstAid.antihistamines]: 'Antihistamines',
  [ITEM_IDS.personal.phone]: 'A cell phone and charger',
  [ITEM_IDS.personal.wallet]: 'Your wallet with credit cards and legal ID inside',
  [ITEM_IDS.personal.keys]: 'Your keys',
  [ITEM_IDS.personal.lipBalm]: 'Lip balm with SPF',
};

const BG: Record<string, string> = {
  [ITEM_IDS.indoors.pillows]: 'Възглавници',
  [ITEM_IDS.indoors.blankets]: 'Одеяла',
  [ITEM_IDS.indoors.sleepingBag]: 'Спален чувал и термоподложка',
  [ITEM_IDS.indoors.airMattress]: 'Надувен матрак, помпа и ремонтен комплект',
  [ITEM_IDS.indoors.powerBank]: 'Външна батерия',
  [ITEM_IDS.outdoors.tent]: 'Палатка според сезона и колчета',
  [ITEM_IDS.outdoors.flashlights]: 'Фенери и/или челни лампи',
  [ITEM_IDS.outdoors.cooler]: 'Голяма хладилна чанта и лед',
  [ITEM_IDS.outdoors.firestarter]: 'Кибрит, запалвачка или запалител',
  [ITEM_IDS.outdoors.kindling]: 'Дърва или въглища за запалване на огън',
  [ITEM_IDS.outdoors.citronella]: 'Свещи с цитронела против насекоми',
  [ITEM_IDS.furniture.pavilion]: 'Сгъваем навес или сенник',
  [ITEM_IDS.furniture.hammock]: 'Хамак',
  [ITEM_IDS.furniture.chairs]: 'Поне по един къмпинг стол на човек',
  [ITEM_IDS.furniture.table]: 'Сгъваема маса',
  [ITEM_IDS.clothes.tshirts]: 'Тениски',
  [ITEM_IDS.clothes.layering]: 'Леки дрехи за наслояване',
  [ITEM_IDS.clothes.raincoat]: 'Дъждобран',
  [ITEM_IDS.clothes.sweater]: 'Пуловер, суитшърт или флис',
  [ITEM_IDS.clothes.socks]: 'Дебели чорапи, най-добре от вълна',
  [ITEM_IDS.clothes.pantsShorts]: 'Панталони и шорти',
  [ITEM_IDS.clothes.underwear]: 'Бельо',
  [ITEM_IDS.clothes.swimsuit]: 'Бански костюм или бански гащи',
  [ITEM_IDS.clothes.sunhat]: 'Широкопроцорна шапка или козирка',
  [ITEM_IDS.clothes.sunglasses]: 'Слънчеви очила',
  [ITEM_IDS.clothes.hikingBoots]: 'Туристически обувки',
  [ITEM_IDS.clothes.sandals]: 'Сандали или джапанки',
  [ITEM_IDS.food.spices]: 'Подправки и билки, включително сол и пипер',
  [ITEM_IDS.food.eggs]: 'Яйца',
  [ITEM_IDS.food.cookingOil]: 'Готварско олио',
  [ITEM_IDS.food.drinks]: 'Бутилирана вода, безалкохолни и сокове',
  [ITEM_IDS.food.smores]:
    'Бонбони за печене, шоколад, бисквити и пръчици (за s\u2019mores)',
  [ITEM_IDS.food.produce]: 'Пресни плодове и зеленчуци',
  [ITEM_IDS.food.meats]: 'Меса за барбекю',
  [ITEM_IDS.food.condiments]: 'Сосове: кетчуп, горчица, релиш и майонеза',
  [ITEM_IDS.food.bread]: 'Хляб',
  [ITEM_IDS.food.deli]: 'Нарязано сирене и месо',
  [ITEM_IDS.food.snacks]: 'Бързи закуски: орехов микс и енергийни барове',
  [ITEM_IDS.food.saltySnacks]: 'Чипс, пръчки или други солени закуски',
  [ITEM_IDS.food.beer]: 'Бира и други напитки',
  [ITEM_IDS.food.foodBowlsWithLids]: 'Купи за храна с капак',
  [ITEM_IDS.food.servingBowls]: 'Големи купи за сервиране',
  [ITEM_IDS.hygiene.handSoap]: 'Сапун за ръце',
  [ITEM_IDS.hygiene.towels]: 'Кърпи за баня и кърпички',
  [ITEM_IDS.hygiene.bodySoap]: 'Сапун, шампоан и балсам',
  [ITEM_IDS.hygiene.hairbrush]: 'Четка за коса',
  [ITEM_IDS.hygiene.toothbrush]: 'Четка и паста за зъби',
  [ITEM_IDS.hygiene.cottonSwabs]: 'Клечки за уши',
  [ITEM_IDS.hygiene.toiletPaper]: 'Тоалетна хартия',
  [ITEM_IDS.hygiene.menstrual]: 'Дамски превръзки/тампони',
  [ITEM_IDS.hygiene.deodorant]: 'Дезодорант',
  [ITEM_IDS.hygiene.babyWipes]: 'Мокри кърпички за бързо почистване между миенения',
  [ITEM_IDS.recreational.fishing]: 'Риболовни въдици и аксесоари',
  [ITEM_IDS.recreational.boardGames]: 'Настолни игри и карти',
  [ITEM_IDS.recreational.books]: 'Книги',
  [ITEM_IDS.recreational.speaker]: 'Музикален плеър и колонка',
  [ITEM_IDS.recreational.binoculars]: 'Бинокъл',
  [ITEM_IDS.recreational.sports]: 'Фризби, волейболни и футболни топки',
  [ITEM_IDS.cleanUp.paperTowels]: 'Хартиени кърпи',
  [ITEM_IDS.cleanUp.trashBags]: 'Торби за боклук',
  [ITEM_IDS.cleanUp.sponge]: 'Гъба за почистване',
  [ITEM_IDS.cleanUp.dirtyClothesBags]: 'Пликове за мръсно бельо',
  [ITEM_IDS.cleanUp.stainRemover]: 'Молив за петна по дрехи',
  [ITEM_IDS.cleanUp.portableSink]: 'Портативна мивка или купа за миене на съдове',
  [ITEM_IDS.safety.handSanitizer]: 'Дезинфектант за ръце',
  [ITEM_IDS.safety.spareCash]: 'Резервни пари в брой',
  [ITEM_IDS.safety.sunscreen]: 'Слънцезащитен крем с висок SPF, водоустойчив',
  [ITEM_IDS.safety.insectRepellant]: 'Репелент против насекоми',
  [ITEM_IDS.safety.spareBatteries]: 'Резервни батерии',
  [ITEM_IDS.firstAid.bandages]: 'Лепенки',
  [ITEM_IDS.firstAid.alcohol]: 'Спирт за дезинфекция',
  [ITEM_IDS.firstAid.antiItch]: 'Лекарство срещу сърбеж',
  [ITEM_IDS.firstAid.tweezers]: 'Пинцета',
  [ITEM_IDS.firstAid.antihistamines]: 'Антихистамини',
  [ITEM_IDS.personal.phone]: 'Мобилен телефон и зарядно',
  [ITEM_IDS.personal.wallet]: 'Портфейл с карти и документи',
  [ITEM_IDS.personal.keys]: 'Ключове',
  [ITEM_IDS.personal.lipBalm]: 'Балсам за устни със SPF',
};

export const ITEM_TEXT: ItemTextMap = { en: EN, bg: BG };
